import { getIn } from 'formik';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';
import FormErrorMessage from '@shared/components/feedback/FormErrorMessage/FormErrorMessage';
import type { FormikTextFieldProps } from './FormikTextField.types';

export const FormikTextField = <Values,>({
  formik,
  name,
  label,
  labelVariant,
  optional,
  placeholder,
  multiline,
  rows,
  inputSx,
  containerSx,
  className,
  onChange,
}: FormikTextFieldProps<Values>): React.JSX.Element => {
  const storedValue = (getIn(formik.values, name) ?? '') as string;
  const isTouched = Boolean(getIn(formik.touched, name));
  const errorMessage = getIn(formik.errors, name) as string | undefined;
  const showsError = isTouched && !!errorMessage;

  return (
    <Stack gap="10px" sx={containerSx}>
      <TextFieldLabel label={label} optional={optional} variant={labelVariant} />
      <TextField
        className={className}
        sx={inputSx}
        name={name}
        placeholder={placeholder}
        multiline={multiline}
        rows={rows}
        value={storedValue}
        onChange={onChange ?? formik.handleChange}
        onBlur={formik.handleBlur}
        error={showsError}
        helperText={showsError ? <FormErrorMessage>{errorMessage}</FormErrorMessage> : null}
      />
    </Stack>
  );
};
